<div *ngIf="civilStatusForm" [formGroup]="civilStatusForm">
  <!-- Identité -->
  <div class="row">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Identité </strong>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-4 col-lg-3">
      <div class="form-check form-check-inline">
        <input id="madam" type="radio" class="form-check-input" formControlName="title" name="title" value="Madam" />
        <label for="madam" class="form-check-label">Madame</label>
      </div>
    </div>
    <div class="col-4 col-lg-3">
      <div class="form-check form-check-inline">
        <input id="mister" type="radio" class="form-check-input" formControlName="title" name="title" value="Mister" />
        <label for="mister" class="form-check-label">Monsieur</label>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12 col-lg-4">
      <div class="mb-3 text-secondary">
        <label>Nom de naissance</label>
        <input type="text" class="form-control" formControlName="surname" />
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="mb-3 text-secondary">
        <label>Nom d'usage</label>
        <input type="text" class="form-control" formControlName="usualName" />
      </div>
    </div>
    <div class="col-12 col-lg-4 mb-3 text-secondary">
      <div class="mb-3 text-secondary">
        <label>Prénom</label>
        <input type="text" class="form-control" formControlName="firstName" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-4 mb-3 text-secondary">
      <label>Date de naissance</label>
      <app-datepicker id="fieldBirthDate" formControlName="birthDate"></app-datepicker>
    </div>
    <div class="col-12 col-lg-4">
      <div class="mb-3 text-secondary">
        <label>Age</label>
        <input type="text" class="form-control" formControlName="ageYears" />
      </div>
    </div>
    <div class="col-12 col-lg-4 mb-3 text-secondary">
      <div class="mb-3 text-secondary">
        <label>Mois</label>
        <input type="text" class="form-control" formControlName="ageMonths" />
      </div>
    </div>
  </div>
  <!-- Nationalité -->
  <div class="row">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Nationalité </strong>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-4">
      <div class="mb-3 text-secondary">
        <label>Nationalité</label>
        <select class="form-select" formControlName="nationality">
          <option value=""></option>
          <option *ngFor="let nationality of nationalities | keyvalue: stringAscOrder" [ngValue]="nationality.key">
            {{ nationality.value }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-12 col-lg-8">
      <div class="mb-3 text-secondary">
        <label class="required">Type de justificatif</label>
        <select
          class="form-select"
          formControlName="credentialType"
          [class.is-invalid]="submitted && civilStatusForm.controls?.credentialType?.invalid"
        >
          <option value=""></option>
          <option *ngFor="let credentialType of filteredCredentialTypes" [ngValue]="credentialType">
            {{ RsjCredentialTypeLabel[credentialType] }}
          </option>
        </select>
        <small *ngIf="submitted && civilStatusForm.controls?.credentialType?.errors?.required" class="form-text text-danger"
          >Le type de justificatif est requis.</small
        >
      </div>
    </div>
  </div>
  <ng-container [ngSwitch]="civilStatusForm.controls.credentialType?.value">
    <ng-container *ngSwitchCase="RsjCredentialType.ValidIdentityFr">
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Pièce d'identité valide</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="piece_identite"
            [titleId]="28"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >La pièce d'identité est requise.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate1"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate1?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="RsjCredentialType.ExpiredIdentityFr">
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Pièce d'identité périmée</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="piece_identite"
            [titleId]="28"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >La pièce d'identité est requise.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate1"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate1?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Récépissé de la demande</label>
          <app-file-input
            formControlName="credentialDocument2"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument2?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument2?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument2?.errors)
            "
            title="recepisse_demande"
            [titleId]="29"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument2?.errors?.required" class="form-text text-danger"
            >Le récépissé est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="RsjCredentialType.NoIdentityFr">
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-6">
          <label class="required">Justificatif d'identité</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="justificatif_identite"
            [titleId]="30"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >Le justificatif d'identité est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
          <small class="form-text text-secondary">Extrait d'acte de naissance, livret de famille ou permis de conduire.</small>
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-6">
          <label class="required">Récépissé de la demande</label>
          <app-file-input
            formControlName="credentialDocument2"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument2?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument2?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument2?.errors)
            "
            title="recepisse_demande"
            [titleId]="31"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument2?.errors?.required" class="form-text text-danger"
            >Le récépissé est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="RsjCredentialType.ValidIdentityEU">
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Pièce d'identité valide</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="piece_identite"
            [titleId]="28"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >La pièce d'identité est requise.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
          <small class="form-text text-secondary"
            >CNI, passeport, carte de ressortissant communautaire, carte de séjour d'un membre de la famille citoyen de l'Union.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate1"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate1?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="RsjCredentialType.ResidentCard">
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Carte de résident ou titre de séjour en cours de validité</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="carte_resident_titre_sejour"
            [titleId]="32"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >La carte de résident / titre de séjour est requise.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
          <small class="form-text text-secondary">Récépissé de la carte de séjour, titre de séjour, carte de résident, statut de réfugié.</small>
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate1"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate1?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="RsjCredentialType.ValidRenewal">
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Récépissé de renouvellement ou de première demande</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="recepisse_renouvellement"
            [titleId]="33"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >Le récépissé de renouvellement ou de première demande est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate1"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate1?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Ancien titre de séjour</label>
          <app-file-input
            formControlName="credentialDocument2"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument2?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument2?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument2?.errors)
            "
            title="titre_sejour"
            [titleId]="32"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument2?.errors?.required" class="form-text text-danger"
            >Le titre de séjour est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate2"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate2?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate2?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate2?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="RsjCredentialType.CJM">
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Attestation Contrat Jeune Majeur</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="attestation_CJM"
            [titleId]="41"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >L'attestation CJM est requise.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
      </div>
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Récépissé de renouvellement ou de première demande</label>
          <app-file-input
            formControlName="credentialDocument2"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument2?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument2?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument2?.errors)
            "
            title="recepisse_CJM"
            [titleId]="42"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument2?.errors?.required" class="form-text text-danger"
            >Le récépissé de renouvellement est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate2"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate2?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate2?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate2?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Justificatif d'identité</label>
          <app-file-input
            formControlName="credentialDocument3"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument3?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument3?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument3?.errors)
            "
            title="justificatif_identite"
            [titleId]="30"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument3?.errors?.required" class="form-text text-danger"
            >Le justificatif d'identité est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument3?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument3?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
          <small class="form-text text-secondary">Passeport, extrait acte de naissance, titre antérieur AFP, ...</small>
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate3"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate3?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate3?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate3?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="RsjCredentialType.Other">
      <div class="row px-3">
        Les documents suivants sont admis : <br />
        <ul>
          <li>
            <strong>Récépissé</strong> de demande de titre de séjour portant la mention "Reconnu
            <strong>réfugié ou admis au titre de l'asile</strong>"
          </li>
          <li>Décision favorable de l'OFPRA ou de la Commission de recours des <strong>réfugiés</strong></li>
          <li>Attestation de l'OFPRA accordant le bénéfice de la <strong>protection subsidiaire</strong></li>
          <li>Récépissé de demande de titre de séjour portant la mention "A obtenu le bénéfice de la protection subsidiaire"</li>
          <li>Récépissé de reconnaissance de la protection internationale</li>
          <li>Autorisation Provisoire de Séjour (APS) portant la mention "Parcours de Sortie de Prostitution"</li>
          <li>
            Prolongation des droits d'un titre ou récépissé périmé en attente de
            <strong>rendez-vous préfecture</strong>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Récépissé attestation ou décision</label>
          <app-file-input
            formControlName="credentialDocument1"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument1?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument1?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument1?.errors)
            "
            title="recepisse_attestation_decision"
            [titleId]="40"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument1?.errors?.required" class="form-text text-danger"
            >Le récépissé attestation ou décision est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument1?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate1"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate1?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate1?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label class="required">Justificatif d'identité</label>
          <app-file-input
            formControlName="credentialDocument2"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument2?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument2?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument2?.errors)
            "
            title="justificatif_identite"
            [titleId]="30"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocument2?.errors?.required" class="form-text text-danger"
            >Le justificatif d'identité est requis.</small
          >
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument2?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
          <small class="form-text text-secondary">Passeport, extrait acte de naissance, titre antérieur AFP, ...</small>
        </div>
        <div class="mb-3 text-secondary col-12 col-xl-4">
          <label class="required">Date de fin de validité</label>
          <app-datepicker
            formControlName="credentialDocumentDate2"
            [invalid]="submitted && civilStatusForm.controls?.credentialDocumentDate2?.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate2?.errors?.required" class="form-text text-danger"
            >La date de fin de validité est requise.</small
          >
          <small *ngIf="submitted && civilStatusForm.controls?.credentialDocumentDate2?.errors?.dateFormat" class="form-text text-danger"
            >Le format de la date est incorrect.</small
          >
        </div>
      </div>
      <div class="row">
        <div class="mb-3 text-secondary col-12 col-xl-8">
          <label>Confirmation rendez-vous préfecture</label>
          <app-file-input
            formControlName="credentialDocument3"
            [beneficiary]="beneficiary"
            [invalid]="
              civilStatusForm.controls?.credentialDocument3?.errors?.fileSize ||
              civilStatusForm.controls?.credentialDocument3?.errors?.fileType ||
              (submitted && civilStatusForm.controls?.credentialDocument3?.errors)
            "
            title="rdv_prefecture"
            [titleId]="34"
            accept="application/pdf,image/png,image/jpeg"
            [maxFileSize]="maxFileSize"
          ></app-file-input>
          <small *ngIf="civilStatusForm.controls?.credentialDocument3?.errors?.fileSize" class="form-text text-danger">
            Le document ne doit pas dépasser {{ maxFileSizeStr }}.
          </small>
          <small *ngIf="civilStatusForm.controls?.credentialDocument3?.errors?.fileType" class="form-text text-danger"
            >Le document doit être de type PDF, PNG ou JPG.</small
          >
        </div>
      </div>
    </ng-container>
  </ng-container>
  <!-- Adresse de résidence -->
  <div class="row mt-3">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Adresse de résidence </strong>
      </p>
    </div>
  </div>
  <ng-container [formGroup]="residentialAddressForm">
    <div class="row">
      <div class="col-12 col-lg-4 mb-3 text-secondary">
        <label>Début à cette adresse</label>
        <app-datepicker id="beginDate" formControlName="beginDate"> </app-datepicker>
      </div>
      <div class="col-12 col-lg-4">
        <div class="mb-3 text-secondary">
          <label>Statut d'habitation</label>
          <select class="form-select" formControlName="residentialStatus">
            <option value=""></option>
            <option
              *ngIf="residentialAddressForm.controls.residentialStatus.value"
              [ngValue]="residentialAddressForm.controls.residentialStatus.value"
            >
              {{ ResidentialStatusLabel[residentialAddressForm.controls.residentialStatus.value] }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="mb-3 text-secondary">
          <label>Complément de statut</label>
          <input type="text" class="form-control" formControlName="residentialStatusComplement" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="mb-3 text-secondary">
          <label>Adresse</label>
          <input type="text" class="form-control" formControlName="address" />
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="mb-3 text-secondary">
          <label>Complément d'adresse</label>
          <input type="text" class="form-control" formControlName="additionalAddress" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="mb-3 text-secondary">
          <label>Ville</label>
          <input type="text" class="form-control" formControlName="city" />
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="mb-3 text-secondary">
          <label>Code postal</label>
          <input type="text" class="form-control" formControlName="postalCode" />
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="mb-3 text-secondary">
          <label>QPV / QVA</label>
          <select class="form-select" formControlName="qpvId">
            <option value=""></option>
            <option *ngFor="let qpv of qpvs" [ngValue]="qpv.id">
              {{ qpv.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="row" *ngIf="residentialStatusCategory === 'HostedByAThird'">
    <div class="mb-3 text-secondary col-12 col-xl-6">
      <label class="required">Attestation d'hébergement de moins de 2 mois</label>
      <app-file-input
        formControlName="addressDocument1"
        [beneficiary]="beneficiary"
        [invalid]="
          civilStatusForm.controls?.addressDocument1?.errors?.fileSize ||
          civilStatusForm.controls?.addressDocument1?.errors?.fileType ||
          (submitted && civilStatusForm.controls?.addressDocument1?.errors)
        "
        title="attestation_hebergement"
        [titleId]="35"
        accept="application/pdf,image/png,image/jpeg"
        [maxFileSize]="maxFileSize"
      ></app-file-input>
      <small *ngIf="submitted && civilStatusForm.controls?.addressDocument1?.errors?.required" class="form-text text-danger"
        >L'attestation d'hébergement est requise.</small
      >
      <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileSize" class="form-text text-danger">
        Le document ne doit pas dépasser {{ maxFileSizeStr }}.
      </small>
      <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileType" class="form-text text-danger"
        >Le document doit être de type PDF, PNG ou JPG.</small
      >
    </div>
    <div class="mb-3 text-secondary col-12 col-xl-6">
      <label class="required">Justificatif de domicile du tiers de moins de 2 mois</label>
      <app-file-input
        formControlName="addressDocument2"
        [beneficiary]="beneficiary"
        [invalid]="
          civilStatusForm.controls?.addressDocument2?.errors?.fileSize ||
          civilStatusForm.controls?.addressDocument2?.errors?.fileType ||
          (submitted && civilStatusForm.controls?.addressDocument2?.errors)
        "
        title="justificatif_domicile"
        [titleId]="36"
        accept="application/pdf,image/png,image/jpeg"
        [maxFileSize]="maxFileSize"
      ></app-file-input>
      <small *ngIf="submitted && civilStatusForm.controls?.addressDocument2?.errors?.required" class="form-text text-danger"
        >Le justificatif de domicile est requis.</small
      >
      <small *ngIf="civilStatusForm.controls?.addressDocument2?.errors?.fileSize" class="form-text text-danger">
        Le document ne doit pas dépasser {{ maxFileSizeStr }}.
      </small>
      <small *ngIf="civilStatusForm.controls?.addressDocument2?.errors?.fileType" class="form-text text-danger"
        >Le document doit être de type PDF, PNG ou JPG.</small
      >
    </div>
  </div>
  <ng-container *ngIf="residentialStatusCategory === 'HostedInFosterCare'">
    <div class="row px-3"><label class="required text-secondary">Justificatif</label></div>
    <div class="row">
      <div class="mb-3 text-secondary col-5">
        <label aria-label="Justificatif de domicile de moins de 2 mois">de domicile de moins de 2 mois</label>
        <app-file-input
          formControlName="addressDocument1"
          [beneficiary]="beneficiary"
          [invalid]="
            civilStatusForm.controls?.addressDocument1?.errors?.fileSize ||
            civilStatusForm.controls?.addressDocument1?.errors?.fileType ||
            (submitted && civilStatusForm.errors?.addressDocRequired)
          "
          title="justificatif_domicile"
          [titleId]="37"
          accept="application/pdf,image/png,image/jpeg"
          [maxFileSize]="maxFileSize"
        ></app-file-input>
        <small *ngIf="submitted && civilStatusForm.errors?.addressDocRequired" class="form-text text-danger"
          >Le justificatif de domicile ou l'attestation CHRS sont requis.</small
        >
        <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileSize" class="form-text text-danger">
          Le document ne doit pas dépasser {{ maxFileSizeStr }}.
        </small>
        <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileType" class="form-text text-danger"
          >Le document doit être de type PDF, PNG ou JPG.</small
        >
      </div>
      <div class="col-1 text-center">
        <strong> OU </strong>
      </div>
      <div class="mb-3 text-secondary col-5">
        <label>Attestation CHRS</label>
        <app-file-input
          formControlName="addressDocument2"
          [beneficiary]="beneficiary"
          [invalid]="
            civilStatusForm.controls?.addressDocument2?.errors?.fileSize ||
            civilStatusForm.controls?.addressDocument2?.errors?.fileType ||
            (submitted && civilStatusForm.errors?.addressDocRequired)
          "
          title="attestation_CHRS"
          [titleId]="38"
          accept="application/pdf,image/png,image/jpeg"
          [maxFileSize]="maxFileSize"
        ></app-file-input>
        <small *ngIf="submitted && civilStatusForm.errors?.addressDocRequired" class="form-text text-danger"
          >Le justificatif de domicile ou l'attestation CHRS sont requis.</small
        >
        <small *ngIf="civilStatusForm.controls?.addressDocument2?.errors?.fileSize" class="form-text text-danger">
          Le document ne doit pas dépasser {{ maxFileSizeStr }}.
        </small>
        <small *ngIf="civilStatusForm.controls?.addressDocument2?.errors?.fileType" class="form-text text-danger"
          >Le document doit être de type PDF, PNG ou JPG.</small
        >
      </div>
    </div>
  </ng-container>

  <div class="row" *ngIf="residentialStatusCategory === 'TenantOwner'">
    <div class="mb-3 text-secondary col-12 col-xl-8">
      <label class="required">Justificatif de domicile de moins de 2 mois</label>
      <app-file-input
        formControlName="addressDocument1"
        [beneficiary]="beneficiary"
        [invalid]="
          civilStatusForm.controls?.addressDocument1?.errors?.fileSize ||
          civilStatusForm.controls?.addressDocument1?.errors?.fileType ||
          (submitted && civilStatusForm.controls?.addressDocument1?.errors)
        "
        title="justificatif_domicile"
        [titleId]="37"
        accept="application/pdf,image/png,image/jpeg"
        [maxFileSize]="maxFileSize"
      ></app-file-input>
      <small *ngIf="submitted && civilStatusForm.controls?.addressDocument1?.errors?.required" class="form-text text-danger"
        >Le justificatif de domicile est requis.</small
      >
      <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileSize" class="form-text text-danger">
        Le document ne doit pas dépasser {{ maxFileSizeStr }}.
      </small>
      <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileType" class="form-text text-danger"
        >Le document doit être de type PDF, PNG ou JPG.</small
      >
    </div>
  </div>
  <!-- Adresse de réception du courrier -->
  <div class="row mt-3">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Adresse de réception du courrier </strong>
      </p>
    </div>
  </div>
  <ng-container [formGroup]="postalAddressForm">
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="mb-3 text-secondary">
          <label>Type de domiciliation</label>
          <select class="form-select" formControlName="domiciliationType">
            <option value=""></option>
            <option *ngIf="postalAddressForm.controls.domiciliationType.value" [ngValue]="postalAddressForm.controls.domiciliationType.value">
              {{ DomiciliationTypeLabel[postalAddressForm.controls.domiciliationType.value] }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="mb-3 text-secondary">
          <label>Complément de domiciliation</label>
          <input type="text" class="form-control" formControlName="domiciliationTypeComplement" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="mb-3 text-secondary">
          <label>Adresse</label>
          <input type="text" class="form-control" formControlName="address" />
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="mb-3 text-secondary">
          <label>Complément d'adresse</label>
          <input type="text" class="form-control" formControlName="additionalAddress" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="mb-3 text-secondary">
          <label>Ville</label>
          <input type="text" class="form-control" formControlName="city" />
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="mb-3 text-secondary">
          <label>Code postal</label>
          <input type="text" class="form-control" formControlName="postalCode" />
        </div>
      </div>
    </div>
  </ng-container>
  <div class="row" *ngIf="residentialStatusCategory === 'Homeless'">
    <div class="mb-3 text-secondary col-12 col-xl-8">
      <label>Attestation de domiciliation de moins de 2 mois</label>
      <app-file-input
        formControlName="addressDocument1"
        [beneficiary]="beneficiary"
        [invalid]="
          civilStatusForm.controls?.addressDocument1?.errors?.fileSize ||
          civilStatusForm.controls?.addressDocument1?.errors?.fileType ||
          (submitted && civilStatusForm.controls?.addressDocument1?.errors)
        "
        title="attestation_domiciliation"
        [titleId]="39"
        accept="application/pdf,image/png,image/jpeg"
        [maxFileSize]="maxFileSize"
      ></app-file-input>
      <small *ngIf="submitted && civilStatusForm.controls?.addressDocument1?.errors?.required" class="form-text text-danger"
        >L'attestation de domiciliation est requise.</small
      >
      <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileSize" class="form-text text-danger">
        Le document ne doit pas dépasser {{ maxFileSizeStr }}.
      </small>
      <small *ngIf="civilStatusForm.controls?.addressDocument1?.errors?.fileType" class="form-text text-danger"
        >Le document doit être de type PDF, PNG ou JPG.</small
      >
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12 col-lg-12 mb-3">
      <div class="form-check">
        <input
          id="sixMonthsResident"
          type="checkbox"
          class="form-check-input"
          formControlName="sixMonthsResident"
          name="sixMonthsResident"
          [class.is-invalid]="submitted && civilStatusForm.controls.sixMonthsResident.invalid"
        />
        <label for="sixMonthsResident" class="form-check-label"
          ><strong>Je déclare sur l’honneur être résident de la Métropole de Lyon depuis au moins 6 mois</strong
          ><span class="text-danger"> *</span></label
        >
        <small *ngIf="submitted && civilStatusForm.controls.sixMonthsResident.errors?.required" class="form-text text-danger"
          >Ce champ est requis.</small
        >
      </div>
    </div>
  </div>
  <!-- Éléments statistiques -->
  <div class="row mt-2" *ngIf="residentialStatusCategory === 'HostedByAThird' || domiciliationTypeCategory === 'CCASAssociation'">
    <div class="col-12 col-lg-12">
      <p>
        <strong> Éléments statistiques </strong><br />
        <small class="text-secondary">Informations à visée statistique n'ayant pas d'incidence sur l'accès au RSJ.</small>
      </p>
    </div>
  </div>
  <ng-container *ngIf="residentialStatusCategory === 'HostedByAThird'">
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Hébergé à titre gratuit ?</label>
      </div>
      <div class="col-12 col-lg-7">
        <div class="form-check form-check-inline">
          <input
            id="hostedFreeOfChargeYes"
            type="radio"
            class="form-check-input"
            formControlName="hostedFreeOfCharge"
            name="hostedFreeOfCharge"
            [class.is-invalid]="submitted && civilStatusForm.controls.hostedFreeOfCharge.invalid"
            [value]="true"
          />
          <label for="hostedFreeOfChargeYes" class="form-check-label">Oui</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="hostedFreeOfChargeNo"
            type="radio"
            class="form-check-input"
            formControlName="hostedFreeOfCharge"
            name="hostedFreeOfCharge"
            [class.is-invalid]="submitted && civilStatusForm.controls.hostedFreeOfCharge.invalid"
            [value]="false"
          />
          <label for="hostedFreeOfChargeNo" class="form-check-label">Non</label>
        </div>
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.hostedFreeOfCharge?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Décohabitation ?</label>
      </div>
      <div class="col-12 col-lg-7">
        <div class="form-check form-check-inline">
          <input
            id="notWished"
            type="radio"
            class="form-check-input"
            formControlName="decohabitationStatus"
            name="decohabitationStatus"
            [class.is-invalid]="submitted && civilStatusForm.controls.decohabitationStatus.invalid"
            value="NotWished"
          />
          <label for="notWished" class="form-check-label">{{ DecohabitationStatus.NotWished }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="wishedInProgress"
            type="radio"
            class="form-check-input"
            formControlName="decohabitationStatus"
            name="decohabitationStatus"
            [class.is-invalid]="submitted && civilStatusForm.controls.decohabitationStatus.invalid"
            value="WishedInProgress"
          />
          <label for="wishedInProgress" class="form-check-label">{{ DecohabitationStatus.WishedInProgress }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="wished"
            type="radio"
            class="form-check-input"
            formControlName="decohabitationStatus"
            name="decohabitationStatus"
            [class.is-invalid]="submitted && civilStatusForm.controls.decohabitationStatus.invalid"
            value="Wished"
          />
          <label for="wished" class="form-check-label">{{ DecohabitationStatus.Wished }}</label>
        </div>
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.decohabitationStatus?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
  </ng-container>
  <ng-container *ngIf="domiciliationTypeCategory === 'CCASAssociation'">
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Inscription à la Maison de la Veille sociale :</label>
      </div>
      <div class="col-12 col-lg-7">
        <div class="form-check form-check-inline">
          <input
            id="shelterRegistrationYes"
            type="radio"
            class="form-check-input"
            formControlName="shelterRegistration"
            name="shelterRegistration"
            [value]="true"
            [class.is-invalid]="submitted && civilStatusForm.controls.shelterRegistration.invalid"
          />
          <label for="shelterRegistrationYes" class="form-check-label">Oui</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="shelterRegistrationNo"
            type="radio"
            class="form-check-input"
            formControlName="shelterRegistration"
            name="shelterRegistration"
            [value]="false"
            [class.is-invalid]="submitted && civilStatusForm.controls.shelterRegistration.invalid"
          />
          <label for="shelterRegistrationNo" class="form-check-label">Non</label>
        </div>
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.shelterRegistration?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Durée de cette situation d’habitation, depuis :</label>
      </div>
      <div class="col-12 col-lg-7">
        <div class="form-check form-check-inline">
          <input
            id="lessThanOneMonth"
            type="radio"
            class="form-check-input"
            formControlName="residentialSituationDuration"
            name="residentialSituationDuration"
            value="LessThanOneMonth"
            [class.is-invalid]="submitted && civilStatusForm.controls.residentialSituationDuration.invalid"
          />
          <label for="lessThanOneMonth" class="form-check-label">{{ ResidentialSituationDuration.LessThanOneMonth }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="betweenOneAndThreeMonths"
            type="radio"
            class="form-check-input"
            formControlName="residentialSituationDuration"
            name="residentialSituationDuration"
            value="BetweenOneAndThreeMonths"
            [class.is-invalid]="submitted && civilStatusForm.controls.residentialSituationDuration.invalid"
          />
          <label for="betweenOneAndThreeMonths" class="form-check-label">{{ ResidentialSituationDuration.BetweenOneAndThreeMonths }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="betweenFourAndSixMonths"
            type="radio"
            class="form-check-input"
            formControlName="residentialSituationDuration"
            name="residentialSituationDuration"
            value="BetweenFourAndSixMonths"
            [class.is-invalid]="submitted && civilStatusForm.controls.residentialSituationDuration.invalid"
          />
          <label for="betweenFourAndSixMonths" class="form-check-label">{{ ResidentialSituationDuration.BetweenFourAndSixMonths }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="moreThanSixMonths"
            type="radio"
            class="form-check-input"
            formControlName="residentialSituationDuration"
            name="residentialSituationDuration"
            value="MoreThanSixMonths"
            [class.is-invalid]="submitted && civilStatusForm.controls.residentialSituationDuration.invalid"
          />
          <label for="moreThanSixMonths" class="form-check-label">{{ ResidentialSituationDuration.MoreThanSixMonths }}</label>
        </div>
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.residentialSituationDuration?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Êtes-vous à la recherche d'un logement ?</label>
      </div>
      <div class="col-12 col-lg-7">
        <div class="form-check form-check-inline">
          <input
            id="searchingForHousingYes"
            type="radio"
            class="form-check-input"
            formControlName="searchingForHousing"
            name="searchingForHousing"
            [value]="true"
            [class.is-invalid]="submitted && civilStatusForm.controls.searchingForHousing.invalid"
          />
          <label for="searchingForHousingYes" class="form-check-label">Oui</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="searchingForHousingNo"
            type="radio"
            class="form-check-input"
            formControlName="searchingForHousing"
            name="searchingForHousing"
            [value]="false"
            [class.is-invalid]="submitted && civilStatusForm.controls.searchingForHousing.invalid"
          />
          <label for="searchingForHousingNo" class="form-check-label">Non</label>
        </div>
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.searchingForHousing?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Avez-vous engagé des démarches pour accéder à un logement ?</label>
      </div>
      <div class="col-12 col-lg-7">
        <div class="form-check form-check-inline">
          <input
            id="housingProcessStartedYes"
            type="radio"
            class="form-check-input"
            formControlName="housingProcessStarted"
            name="housingProcessStarted"
            [value]="true"
            [class.is-invalid]="submitted && civilStatusForm.controls.housingProcessStarted.invalid"
          />
          <label for="housingProcessStartedYes" class="form-check-label">Oui</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="housingProcessStartedNo"
            type="radio"
            class="form-check-input"
            formControlName="housingProcessStarted"
            name="housingProcessStarted"
            [value]="false"
            [class.is-invalid]="submitted && civilStatusForm.controls.housingProcessStarted.invalid"
          />
          <label for="housingProcessStartedNo" class="form-check-label">Non</label>
        </div>
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.housingProcessStarted?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Si oui, êtes-vous accompagné dans cette démarche ?</label>
      </div>
      <div class="col-12 col-lg-7">
        <div class="form-check form-check-inline">
          <input
            id="housingProcessWithHelpYes"
            type="radio"
            class="form-check-input"
            formControlName="housingProcessWithHelp"
            name="housingProcessWithHelp"
            [value]="true"
            [class.is-invalid]="submitted && civilStatusForm.controls.housingProcessWithHelp.invalid"
          />
          <label for="housingProcessWithHelpYes" class="form-check-label">Oui</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            id="housingProcessWithHelpNo"
            type="radio"
            class="form-check-input"
            formControlName="housingProcessWithHelp"
            name="housingProcessWithHelp"
            [value]="false"
            [class.is-invalid]="submitted && civilStatusForm.controls.housingProcessWithHelp.invalid"
          />
          <label for="housingProcessWithHelpNo" class="form-check-label">Non</label>
        </div>
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.housingProcessWithHelp?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
      <div class="col-12 col-lg-5">
        <label class="float-start">Si oui, par qui ?</label>
      </div>
      <div class="col-12 col-lg-7">
        <input
          type="text"
          class="form-control"
          formControlName="housingProcessWithHelpBy"
          [class.is-invalid]="submitted && civilStatusForm.controls.housingProcessWithHelpBy.invalid"
        />
      </div>
      <small *ngIf="submitted && civilStatusForm.controls?.housingProcessWithHelpBy?.errors?.required" class="form-text text-danger ms-3"
        >Ce champ est requis.</small
      >
    </div>
  </ng-container>
</div>
